import { isRoomsPath } from '../../service/constants';

export const primaryNavKeyFromPathname = (pathname = '/') => {
  if (isRoomsPath(pathname)) return 'groups';
  if (pathname.startsWith('/family-tree')) return 'family-tree';
  if (pathname.startsWith('/graves')) return 'graves';
  if (pathname.startsWith('/store')) return 'store';
  if (pathname === '/' || pathname.startsWith('/sparks')) return 'home';
  return null;
};
